import { NavLink, Outlet } from "react-router-dom"
import Header from "../../components/Header"
const NavigationItem: React.FC<{ to?: string, title: string }> = ({ to = "/", title }) => {
    return <NavLink end className={({ isActive }) => `rounded-t-lg ${isActive ? "text-zinc-700 bg-white" : "bg-transparent text-white"} px-5 py-2`} to={to}>{title}</NavLink>
}

const LeagueNavigation = () => {
    return (
        <div className="px-5 md:px-32 flex items-center gap-5 bg-[#faa700] overflow-x-auto">
            {/* <NavigationItem to={`/league`} title="Inicio" /> */}
            <NavigationItem to={`/league/first-division`} title="Primera Division" />
            <NavigationItem to={`/league/second-division`} title="Segunda Division" />
            <NavigationItem to={`/league/third-division`} title="Tercera Division" />
        </div>
    )
}
const LeaguePage = () => {
    return (
        <div className="flex flex-col">
            <Header className="flex flex-col gap-5 bg-[#faa700]">
                <p className="text-white font-extrabold uppercase text-4xl">Liga Ignaki</p>
                <p className="text-white">Acá podes ver las noticias sobre la liga y la tabla de posiciones</p>
            </Header>
            <LeagueNavigation />

            <Outlet />
        </div>
    )
}

export default LeaguePage